"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValuesByFieldIds = void 0;
const underscore_1 = __importDefault(require("underscore"));
const json_1 = require("../commonUtils/json");
const getValuesByFieldIds = (fieldIds, sectionData, fields) => {
    if (underscore_1.default.isEmpty(sectionData))
        return {};
    let result = {};
    underscore_1.default.forEach(fieldIds, (fieldId) => {
        const fieldPath = [];
        let field = fields.find((f) => f.id.toString() === fieldId.toString());
        if (field) {
            fieldPath.push(field);
            while (underscore_1.default.isString(field?.parent) || underscore_1.default.isNumber(field?.parent)) {
                field = fields.find((f) => f.id.toString() === field.parent.toString());
                if (field) {
                    fieldPath.push(field);
                }
            }
        }
        fieldPath.reverse();
        const resolved = resolveFieldPath(fieldPath, sectionData, true);
        result = merge(result, resolved);
    });
    return result;
};
exports.getValuesByFieldIds = getValuesByFieldIds;
const resolveFieldPath = (fieldPath, data, first) => {
    if (underscore_1.default.isEmpty(fieldPath))
        return {};
    const result = {};
    if (first) {
        const firstField = fieldPath[0];
        if (firstField.field_type === 'list') {
            const jsonKey = (0, json_1.getJsonKeyFromField)(firstField);
            const list = data[jsonKey];
            if (underscore_1.default.isEmpty(list))
                return {};
            underscore_1.default.forEach(list, (item) => {
                if (!item)
                    return;
                if (result[item._id] === undefined) {
                    result[item._id] = [];
                }
                const resolved = resolveFieldPath(fieldPath.slice(1), item, false);
                result[item._id].push(resolved);
            });
        }
    }
    else {
        let res;
        const field = fieldPath[0];
        const key = (0, json_1.getJsonKeyFromField)(field);
        switch (field.field_type) {
            case 'list':
                res = resolveList(fieldPath.slice(1), data[key]);
                break;
            case 'group':
                res = resolveFieldPath(fieldPath.slice(1), data[key] ?? {}, false);
                break;
            default:
                if (underscore_1.default.isUndefined(data[key])) {
                    res = null;
                }
                else {
                    res = data[key];
                }
                break;
        }
        return res;
    }
    return result;
};
const resolveList = (fieldPath, data) => {
    const result = {};
    if (underscore_1.default.isEmpty(data))
        return {};
    underscore_1.default.forEach(data, (item) => {
        const resolved = resolveFieldPath(fieldPath, item, false);
        result[item._id] = resolved;
    });
    return result;
};
const merge = (obj1, obj2) => {
    const result = {};
    underscore_1.default.forEach(obj1, (value, key) => {
        if (obj2[key] === undefined) {
            result[key] = value;
        }
        else {
            if (underscore_1.default.isArray(value)) {
                result[key] = [...value, ...obj2[key]];
            }
            else if (underscore_1.default.isObject(value)) {
                result[key] = merge(value, obj2[key]);
            }
            else {
                result[key] = value;
            }
        }
    });
    underscore_1.default.forEach(obj2, (value, key) => {
        if (obj1[key] === undefined) {
            result[key] = value;
        }
    });
    return result;
};
